export default __webpack_public_path__ + "images/logoKhusKhus.f93d8957b19e5c835dd2c8fc7456e5f8.svg"